export default {"src":"/_next/static/media/Film.54e55d0a.svg","height":25,"width":25};